import { ClipLoader } from "react-spinners";
import RefundSummaryRows from "./RefundSummaryRows";

const AuthoriseStep = ({ savedForm, institution, submitting, onConfirm }) => (
  <>
    <h2 className="pt-2 pb-4 font-semibold">Confirm refund amount</h2>
    <p className="pb-6">
      We will automatically transfer you to your bank to authorise the payment
      via our partner Yapily.
    </p>
    <RefundSummaryRows
      amount={savedForm.amount}
      accountHolderName={savedForm.accountHolderName}
      reference={savedForm.reference}
      accountNumber={savedForm.accountNumber}
      sortCode={savedForm.sortCode}
    />
    <button
      disabled={submitting}
      onClick={onConfirm}
      className="flex w-full justify-center gap-2 border border-zinc-200 hover:border-primary py-3 px-5 items-center rounded-lg mt-8 shadow-sm"
    >
      {submitting ? (
        <>
          <ClipLoader size={12} className="mr-2 text-primary" /> Setting up
          payment
        </>
      ) : (
        <>
          <img
            className="size-8"
            src={institution.iconUrl}
            alt={institution.name}
          />
          <span className="text-sm">Authorise with {institution.name}</span>
        </>
      )}
    </button>
  </>
);

export default AuthoriseStep;
